// GrowthBook feature-flag keys consumed on the web client. The backend's
// `GET /v1/config` is a generic proxy that returns every flag evaluated for the
// user, so adding a key here (and creating it in GrowthBook) needs no backend
// change. Keep the magic strings in one place.
export const FEATURE_FLAGS = {
  // Boolean — extends the email-confirm cancel step to Visa subscriptions.
  // Off ⇒ Visa keeps the inline one-tap confirm (today's behaviour); on ⇒ Visa
  // joins Non-Visa on the emailed-link confirmation, so it can be ramped and
  // pulled on its own.
  // Never applies in compliance-sensitive geos: those skip the funnel entirely
  // and this gate sits behind that check, not beside it.
  WEB_CANCEL_EMAIL_CONFIRM_VISA: 'webCancelEmailConfirmVisa',
  // Boolean — when on, users arriving from a native app must sign in before
  // reaching membership-info instead of being carried in by the autologin
  // handoff. Off ⇒ today's behaviour. Exempts the compliance-sensitive set;
  // see core/auth/membership-login-wall.ts for the geo rules and for the
  // dependency on auto-login tokens staying reusable, which must be read before
  // this is switched on.
  WEB_MEMBERSHIP_LOGIN_WALL: 'webMembershipLoginWall',
  // STRING, not boolean: `control` is a value, not an absence, so it is compared rather than
  // read as presence. The Mastery arm is what puts the Collection in Discover's tab slot.
  COLLECTION_MASTERY_ARM: 'pabLcCollectionMastery',
  // STRING, like the one above. The served value reverses the key's word order, so it is
  // spelled once in UPDATED_PROFILE_TREATMENT and read from there.
  UPDATED_PROFILE_ARM: 'pabLcUpdatedProfile',
} as const

/** The arm that gets the Collection. Anything else, including `control`, keeps Discover. */
export const COLLECTION_MASTERY_TREATMENT = 'collection'

/** The arm that gets the redesigned profile. Anything else, including `control`, keeps today's. */
export const UPDATED_PROFILE_TREATMENT = 'profileUpdated'

export type FeatureFlagKey = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS]
